angular.module('swapick')
.directive('clickDelegate', clickDelegate)

function clickDelegate() {
  return {
    restrict: 'A',
    priority: 100,
    link: function (scope, iElement, iAttrs) {
      iElement.bind('click', () => {
        const element = angular.element(document.querySelector(iAttrs.clickDelegate));
        const cb = document.querySelector(iAttrs.clickDelegate);
        var event; // The custom event that will be created
        event = document.createEvent('MouseEvents');
        event.initMouseEvent('click', true, true, window);
        element[0].dispatchEvent(event);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/helpers.js